/**
 * Tiny production-foundation utilities. Kept local so the production layer has no
 * dependency on the (V1) shared barrel — it can outlive the V1 cleanup untouched.
 */

/** Join truthy class names. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
